module.exports = __webpack_public_path__ + "static/media/banner_header.f476e635.png";